import { message, Modal, Space } from 'antd'
import { PsIcon } from '../Icons/PsIcon'
import styles from './styles.module.scss'
import { useEffect, useState, useCallback } from 'react'
import { GET_SHIBEI_TOKEN } from '@/api/MaterialApi'

export type AiPsButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSave?: (newInfo: any) => Promise<void>
}

const PS_EDITOR_URL = 'https://ps.zcbot.cn/index.html'

function getFileNameFromUrl(imageInfo: any) {
  const pathname = imageInfo?.url
  return pathname?.split('/').pop()
}
export function AiPsButton(props: AiPsButtonProps) {
  const { originImgUrl, onSave, imageInfo, productCode } = props
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [iframeUrl, setIframeUrl] = useState<string | null>(null)

  const openModal = async () => {
    if (originImgUrl) {
      const res = await GET_SHIBEI_TOKEN()
      const token = res.data
      const params = {
        files: [originImgUrl],
        extra: {
          token: token,
          api: 'https://open-api.zcbot.cn/webps-api/ps/upload',
          formats: ['jpg:0.9', 'png'],
        },
      }
      setIframeUrl(`${PS_EDITOR_URL}#${encodeURI(JSON.stringify(params))}`)
      setIsModalOpen(true)
    } else {
      console.warn('Original image URL is not provided for AI PS Button.')
      // message.warning('请先提供图片');
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setIframeUrl(null)
  }

  const handlePostResult = useCallback(
    async (event: MessageEvent) => {
      if (event.origin !== 'https://ps.zcbot.cn') {
        console.warn('Message from untrusted origin:', event.origin)
        return
      }
      if (
        event.data &&
        event.data.action === 'zcbot:ps:save-success:callback'
      ) {
        const result = event.data.result
        if (result && result.code === 0 && result.data) {
          console.info('在线PS保存成功，结果图: ', result.data)
          onSave?.({
            ...imageInfo,
            url: result.data,
          })
          closeModal()
          // const res = await UPLOAD_PS_IMAGE({
          //   url: result.data,
          //   // productCode: imageInfo?.productCode,
          //   fileName: getFileNameFromUrl(imageInfo),
          //   productCode: productCode,
          // })
          // if (res.code === 0) {
          //   await onSave?.(res.data?.[0])
          //   // message.success('图片已保存');
          //   closeModal()
          // } else {
          //   message.error(res.msg || '上传图片失败')
          // }
        } else {
          console.error('在线PS保存失败:', result ? result.msg : '未知错误')
          // message.error(result.msg || '在线PS保存失败');
        }
      }
    },
    [onSave],
  )

  useEffect(() => {
    if (isModalOpen) {
      window.addEventListener('message', handlePostResult)
    } else {
      window.removeEventListener('message', handlePostResult)
    }
    return () => {
      window.removeEventListener('message', handlePostResult)
    }
  }, [isModalOpen, handlePostResult])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <PsIcon />
        <span>在线PS</span>
      </Space>
      <Modal
        title={'在线PS (Ctrl+S 保存)'}
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        width={'90%'}
        style={{ top: 20 }}
        bodyStyle={{ height: 'calc(100vh - 120px)', padding: 0 }} // Adjust height as needed
        destroyOnClose //
        zIndex={2000}
      >
        {iframeUrl && (
          <iframe
            id="ps-editor-iframe"
            src={iframeUrl}
            width="100%"
            height="100%"
            title="在线PS编辑器"
          ></iframe>
        )}
      </Modal>
    </>
  )
}
import { message, Modal, Space } from 'antd'
import { PsIcon } from '../Icons/PsIcon'
import styles from './styles.module.scss'
import { useEffect, useState, useCallback } from 'react'
import { GET_SHIBEI_TOKEN } from '@/api/MaterialApi'

export type AiPsButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSave?: (newInfo: any) => Promise<void>
}

const PS_EDITOR_URL = 'https://ps.zcbot.cn/index.html'

function getFileNameFromUrl(imageInfo: any) {
  const pathname = imageInfo?.url
  return pathname?.split('/').pop()
}
export function AiPsButton(props: AiPsButtonProps) {
  const { originImgUrl, onSave, imageInfo, productCode } = props
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [iframeUrl, setIframeUrl] = useState<string | null>(null)

  const openModal = async () => {
    if (originImgUrl) {
      const res = await GET_SHIBEI_TOKEN()
      const token = res.data
      const params = {
        files: [originImgUrl],
        extra: {
          token: token,
          api: 'https://open-api.zcbot.cn/webps-api/ps/upload',
          formats: ['jpg:0.9', 'png'],
        },
      }
      setIframeUrl(`${PS_EDITOR_URL}#${encodeURI(JSON.stringify(params))}`)
      setIsModalOpen(true)
    } else {
      console.warn('Original image URL is not provided for AI PS Button.')
      // message.warning('请先提供图片');
    }
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setIframeUrl(null)
  }

  const handlePostResult = useCallback(
    async (event: MessageEvent) => {
      if (event.origin !== 'https://ps.zcbot.cn') {
        console.warn('Message from untrusted origin:', event.origin)
        return
      }
      if (
        event.data &&
        event.data.action === 'zcbot:ps:save-success:callback'
      ) {
        const result = event.data.result
        if (result && result.code === 0 && result.data) {
          console.info('在线PS保存成功，结果图: ', result.data)
          onSave?.({
            ...imageInfo,
            url: result.data,
          })
          closeModal()
          // const res = await UPLOAD_PS_IMAGE({
          //   url: result.data,
          //   // productCode: imageInfo?.productCode,
          //   fileName: getFileNameFromUrl(imageInfo),
          //   productCode: productCode,
          // })
          // if (res.code === 0) {
          //   await onSave?.(res.data?.[0])
          //   // message.success('图片已保存');
          //   closeModal()
          // } else {
          //   message.error(res.msg || '上传图片失败')
          // }
        } else {
          console.error('在线PS保存失败:', result ? result.msg : '未知错误')
          // message.error(result.msg || '在线PS保存失败');
        }
      }
    },
    [onSave],
  )

  useEffect(() => {
    if (isModalOpen) {
      window.addEventListener('message', handlePostResult)
    } else {
      window.removeEventListener('message', handlePostResult)
    }
    return () => {
      window.removeEventListener('message', handlePostResult)
    }
  }, [isModalOpen, handlePostResult])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <PsIcon />
        <span>在线PS</span>
      </Space>
      <Modal
        title={'在线PS (Ctrl+S 保存)'}
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        width={'90%'}
        style={{ top: 20 }}
        bodyStyle={{ height: 'calc(100vh - 120px)', padding: 0 }} // Adjust height as needed
        destroyOnClose //
        zIndex={2000}
      >
        {iframeUrl && (
          <iframe
            id="ps-editor-iframe"
            src={iframeUrl}
            width="100%"
            height="100%"
            title="在线PS编辑器"
          ></iframe>
        )}
      </Modal>
    </>
  )
}
